import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { listSubscribers } from "../api";
import { PageHeader } from "./Dashboard";
import RefreshButton from "../components/RefreshButton";

export default function Subscribers() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = () => {
    setLoading(true);
    listSubscribers().then(setSubs).finally(() => setLoading(false));
  };
  useEffect(reload, []);

  const exportCsv = () => {
    const rows = ["email,subscribed_at"].concat(
      subs.map((s) => `${s.email},${s.subscribed_at || ""}`)
    );
    const blob = new Blob([rows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `asvasa-subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-subscribers">
      <PageHeader eyebrow="Marketing" title="Newsletter subscribers" sub={`${subs.length} readers on the list`} />
      <div className="p-10 max-w-4xl">
        <div className="flex items-center justify-between mb-6">
          <RefreshButton onClick={reload} loading={loading} testid="admin-subscribers-refresh" />
          <button
            onClick={exportCsv}
            disabled={subs.length === 0}
            className="border border-[#2a2a2d] text-[#c3ba9e] px-5 py-3 text-[11px] tracking-[0.28em] uppercase hover:bg-[#1f1f21] disabled:opacity-50 flex items-center gap-2"
            data-testid="admin-subscribers-export"
          >
            <Download size={14} /> Export CSV
          </button>
        </div>

        <div className="bg-[#161617] border border-[#2a2a2d]">
          <div className="grid grid-cols-[2fr_1fr] gap-4 px-6 py-4 border-b border-[#2a2a2d] text-[10px] tracking-[0.28em] uppercase text-[#8c8a7e]">
            <span>Email</span>
            <span>Subscribed</span>
          </div>
          {loading ? (
            <p className="p-10 text-center text-[#8c8a7e] text-sm">Loading…</p>
          ) : subs.length === 0 ? (
            <p className="p-10 text-center text-[#8c8a7e] text-sm">No subscribers yet.</p>
          ) : (
            subs.map((s) => (
              <div key={s.email} className="grid grid-cols-[2fr_1fr] gap-4 px-6 py-3 border-b border-[#2a2a2d] hover:bg-[#1a1a1c]">
                <span className="text-[#e9e6db] text-sm">{s.email}</span>
                <span className="text-[#8c8a7e] text-xs">{s.subscribed_at ? new Date(s.subscribed_at).toLocaleString() : "—"}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
